export default __webpack_public_path__ + "static/media/img_step_lucia03_w.0516f306.jpg";